// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2Ajf-","primary":"Button_primary__CVuDV","small":"Button_small__523vy","secondary":"Button_secondary__19x43"};